import React, { useEffect, useRef } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import Cookies from "universal-cookie";

import { ContentCard } from "../../components/content_card/ContentCard.js";
import { useProcessStore, useAuthenticationStore } from "../../stores/generalStore.js";

const cookies = new Cookies();

const LoginScene = () => {
	const isAuthed = useAuthenticationStore((state) => state.authenticated);
	return (
		!isAuthed && <ContentCard
			location="login"
			width="460"
		>
			<LoginForm />
		</ContentCard>
	);
};

const LoginForm = () => {
	const navigate = useNavigate();
	const isAuthed = useAuthenticationStore((state) => state.authenticated);
	const logIn = useAuthenticationStore((state) => state.logIn);
	const setDefaultAddress = useProcessStore((state) => state.setDefaultAddress);

	const [userMail, setUserMail] = useState("");
	const [userPass, setUserPass] = useState("");
	const [inputClass, setInputClass] = useState("");

	const handleMailChange = (event) => {
		setUserMail(event.target.value.replace(/\s/g, ""));
	};
	const handlePassChange = (event) => {
		setUserPass(event.target.value);
	};


    const addErrorClass = () => { setInputClass('error'); }
    const removeErrorClass = () => { setInputClass(''); }

	const attemptLogin = (event) => {
        event.preventDefault();

		axios.post("https://dpd.pmmaterialy.cz/validate_login.php", {
            email: userMail,
            password: userPass,
        }).then( ( response ) => {
            //console.log(response);
            if ( response.data.login_token?.length === 64) {
                cookies.set('login_token', response.data.login_token, { path: '/' });
                //console.log('cookie set (' + response.data.login_token + ')');

                logIn( response.data.email, response.data.role ).then(() => {
                    setDefaultAddress({
                        company: response.data.default_company,
                        name: response.data.default_name,
                        surname: response.data.default_surname,
                        email: response.data.email,
                        phone: response.data.default_phone,
                        street: response.data.default_street,
                        city: response.data.default_city,
                        zip: response.data.default_zip,
                    });
                    navigate('/');
                })
            } else {
                console.log("error");
                //console.log(response.data);

                addErrorClass();

            }
        });
	};

    useEffect( () => {
        if ( isAuthed ) {
            // if logged in, navigate to main_selection
            navigate('/');
        } else if ( cookies.get('login_token') ) {
            // attempt login via login_token validation
            axios.post("https://dpd.pmmaterialy.cz/validate_login.php", {
                login_token: cookies.get('login_token')
            }).then( ( response ) => {
                //console.log(response.data);
                if ( response.data === 'token invalid') {
                    cookies.remove('login_token');
                } else {
                    //console.log('token_accepted');
                    logIn( response.data.email, response.data.role ).then(() => {
                        setDefaultAddress({
                            company: response.data.default_company,
                            name: response.data.default_name,
                            surname: response.data.default_surname,
                            email: response.data.email,
                            phone: response.data.default_phone,
                            street: response.data.default_street,
                            city: response.data.default_city,
                            zip: response.data.default_zip,
                        });
                        navigate("/");
                    })
                }
            });
        }
    }, [isAuthed]);

	return (
		<form onSubmit={ (e) => attemptLogin(e) }>
			<label htmlFor="user_mail">Emailová adresa</label>
			<input
                required
				id="user_mail"
				type="text"
				onChange={(e) => handleMailChange(e)}
				value={userMail} 
                className={inputClass}
                onAnimationEnd={ () => removeErrorClass() }
			/>
			<label htmlFor="user_pass">Heslo</label>
			<input
                required
				id="user_pass"
				type="password"
				onChange={(e) => handlePassChange(e)}
				value={userPass}
                className={inputClass}
			/>
			<Link to="/forgot_pass">Zapomněl/a jsem heslo</Link>
			<button className={inputClass}>Přihlásit se</button>
		</form>
	);
};

export default LoginScene;
